import ApiService from "../../core/service/ApiService"
import { apigateway } from "../../intances/apigateway"
import React from "react"

export default function useOfferRentalVoucher(setIsLoading, setHasCustomerRentalVoucher) {
  const [error, setError] = React.useState(null)

  const generateRentalVoucher = async (tunnelData, { transactionId }) => {
    const apiUri = `${tunnelData?.apiUrl}middle-business-service/api/v2/transactions/${transactionId}/generate-rental-voucher`
    return apigateway(tunnelData).get(apiUri)
  }

  const getOfferRentalVoucher = async (apiUrl, access_token, payload) => {
    const apiUri = `${apiUrl}middle-business-service/api/v1/documents/file-search`

    const headers = {
      Authorization: `Bearer ${access_token}`,
      Accept: "*/*"
    }

    return ApiService.postForEvollisApi(apiUri, payload, { headers, responseType: "blob" })
      .then((response) => {
        if (response?.size === 0) {
          throw new Error("NO_VOUCHER_FOR_ORDER")
        }
        const file = new Blob([response], { type: "application/pdf" })
        return URL.createObjectURL(file)
      })
      .catch((err) => {
        throw err.message || err.response
      })
      .finally(() => setIsLoading(false))
  }

  const printRentalVoucher = async (apiUrl, access_token, payload) => {
    setIsLoading(true)
    getOfferRentalVoucher(apiUrl, access_token, payload)
      .then((fileURL) => {
        const link = document.createElement("a")
        link.href = fileURL
        window.open(link, "_blank")
        link.remove()
        setHasCustomerRentalVoucher(true)
      })
      .catch((error) => {
        setHasCustomerRentalVoucher(false)
        console.error("printRentalVoucher error : \n", error)
        setError(error)
      })
  }

  return { printRentalVoucher, generateRentalVoucher, error }
}
